// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2gmBO","choiceBoxes":"toolbarselects_choiceBoxes__YuRpQ","simpleField":"toolbarselects_simpleField__2bvUs"};